import { ServiceData } from '@/types';

import articles from './FITNESS_ARTICLES_DE.json';
import exercises from './FITNESS_EXERCISES_DE.json';
import recipes from './FITNESS_RECIPES_DE.json';

export const FITNESS_DATA_DE: ServiceData = {
  articles,
  exercises,
  recipes,
};
